import { Component, inject, OnInit } from '@angular/core';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { LocalStorageKeys } from 'shared/types/local-storage-keys.enum';

@Component({
  selector: 'app-documents-received',
  standalone: true,
  imports: [KorviuButtonComponent, TranslateModule, NzModalModule, NzIconModule],
  templateUrl: './documents-received.component.html',
  styleUrl: './documents-received.component.scss'
})
export class DocumentsReceivedComponent implements OnInit {
  private _modal = inject(NzModalRef);

  public onContinueClick(): void {
    this._modal.destroy();
  }

  public ngOnInit() {
    localStorage.removeItem(LocalStorageKeys.SHOW_DOCUMENTS_RECEIVED_MODAL);
  }
}
